<template>
  <main class="mall_main max-w-[60rem] mx-auto mb-40">
    <div class="px-5 py-14">
      <div class="w-fit flex justify-center items-center bg-slate-100 rounded-full mx-auto px-4 py-1 text-sm">
        {{ currentDate }}
      </div>
      <div class="w-full my-5">
        <div>
          <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M25.4958 0.5C21.1585 0.498539 16.8954 1.62552 13.1255 3.7702C9.35555 5.91488 6.20845 9.00347 3.99339 12.7325C1.77834 16.4615 0.571559 20.7027 0.491621 25.0392C0.411682 29.3758 1.46134 33.6585 3.53745 37.4667L0.579124 47.8417C0.475029 48.206 0.472256 48.5918 0.571103 48.9575C0.66995 49.3233 0.866674 49.6552 1.1401 49.9175C1.41353 50.1798 1.75331 50.3625 2.12287 50.4461C2.49244 50.5296 2.87779 50.5108 3.23745 50.3917L12.9791 47.1458C16.2994 49.0645 20.0165 50.1936 23.8429 50.4458C27.6693 50.6981 31.5025 50.0667 35.0459 48.6005C38.5893 47.1344 41.7479 44.8727 44.2774 41.9905C46.8068 39.1083 48.6394 35.6829 49.6332 31.9791C50.627 28.2754 50.7555 24.3927 50.0087 20.6314C49.2619 16.8701 47.6599 13.331 45.3265 10.2878C42.9931 7.24472 39.9909 4.77918 36.5522 3.08195C33.1135 1.38471 29.3305 0.501281 25.4958 0.5Z"
              fill="url(#paint0_linear_54_4)"
            />
            <path
              d="M17.1624 21.3333C17.1624 20.7808 17.3819 20.2509 17.7726 19.8602C18.1633 19.4695 18.6932 19.25 19.2458 19.25H31.7458C32.2983 19.25 32.8282 19.4695 33.2189 19.8602C33.6096 20.2509 33.8291 20.7808 33.8291 21.3333C33.8291 21.8859 33.6096 22.4158 33.2189 22.8065C32.8282 23.1972 32.2983 23.4167 31.7458 23.4167H19.2458C18.6932 23.4167 18.1633 23.1972 17.7726 22.8065C17.3819 22.4158 17.1624 21.8859 17.1624 21.3333ZM19.2458 27.5833H27.5791C28.1316 27.5833 28.6615 27.8028 29.0522 28.1935C29.4429 28.5842 29.6624 29.1141 29.6624 29.6667C29.6624 30.2192 29.4429 30.7491 29.0522 31.1398C28.6615 31.5305 28.1316 31.75 27.5791 31.75H19.2458C18.6932 31.75 18.1633 31.5305 17.7726 31.1398C17.3819 30.7491 17.1624 30.2192 17.1624 29.6667C17.1624 29.1141 17.3819 28.5842 17.7726 28.1935C18.1633 27.8028 18.6932 27.5833 19.2458 27.5833Z"
              fill="url(#paint1_linear_54_4)"
            />
            <defs>
              <linearGradient id="paint0_linear_54_4" x1="2.28329" y1="9.875" x2="45.9333" y2="84.2958" gradientUnits="userSpaceOnUse">
                <stop stop-color="#0FAFFF" />
                <stop offset="1" stop-color="#CC23D1" />
              </linearGradient>
              <linearGradient id="paint1_linear_54_4" x1="18.6208" y1="19.4708" x2="20.1958" y2="33.0042" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FDFDFD" />
                <stop offset="1" stop-color="#CCEAFF" />
              </linearGradient>
            </defs>
          </svg>
          <p class="text-2xl font-medium mt-3">AI 분석 결과</p>
          <div class="bg-neutral-100 rounded-lg p-4 mt-3">
            <p class="text-neutral-900 text-lg">"{{ searchQuestion || "검색 질문" }}"에 대한 답변입니다.</p>
            <div v-if="searchKeywords && searchKeywords.length > 0" class="mt-3">
              <span class="text-sm text-gray-600">검색 키워드:</span>
              <span v-for="(keyword, index) in searchKeywords" :key="keyword" class="text-sm text-gray-600 font-medium">
                <span>{{ keyword }}</span>
                <span v-if="index < searchKeywords.length - 1" class="text-sm text-gray-600">,</span>
              </span>
            </div>

            <!-- 로딩 상태 (첫 로드) -->
            <div v-if="isLoading && currentPage === 1" class="mt-5 text-center py-10">
              <p class="text-gray-600">검색 중입니다...</p>
            </div>

            <!-- 검색 결과 -->
            <div v-else-if="allItems.length > 0" class="mt-3">
              <!-- 결과 개수 표시 -->
              <p class="text-sm text-gray-600 mb-3">총 {{ totalItems.toLocaleString() }}개의 결과</p>

              <!-- 결과 목록 -->
              <div v-for="item in allItems" :key="item.id" class="flex items-center gap-3 mt-3 p-3 border border-neutral-200 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
                <router-link :to="'/mall/view/' + item.id" target="_blank" class="w-full flex items-center gap-3">
                  <div class="w-24 h-24 rounded-lg overflow-hidden flex-shrink-0">
                    <img v-if="getThumbnailLink(item)" :src="'https://eduwind-api.nodeblack.net/' + getThumbnailLink(item)" :alt="item.title" class="w-full h-full object-cover" />
                    <img v-else src="@/assets/img/null_img.jpg" :alt="item.title" class="w-full h-full object-cover" />
                  </div>

                  <div class="flex-1">
                    <p class="font-medium text-gray-900 line-clamp-2">{{ item.title }}</p>
                    <p class="mt-2 text-sm text-gray-600">{{ item.isFree || item.regularPrice === 0 ? "무료" : item.regularPrice.toLocaleString() + "원" }}</p>
                  </div>
                </router-link>
              </div>

              <!-- 더보기 버튼 -->
              <div v-if="hasMoreResults" class="mt-5 text-center">
                <button
                  @click="loadMoreResults"
                  :disabled="isLoading"
                  class="w-full max-w-md mx-auto px-6 py-3 border border-neutral-300 rounded-lg text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  <span v-if="isLoading" class="flex items-center justify-center gap-2">
                    <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span>로딩 중...</span>
                  </span>
                  <span v-else>더보기 ({{ allItems.length }} / {{ totalItems }})</span>
                </button>
              </div>

              <!-- 모든 결과 로드 완료 메시지 -->
              <div v-else class="mt-5 text-center py-3">
                <p class="text-sm text-gray-500">모든 검색 결과를 불러왔습니다.</p>
              </div>
            </div>

            <!-- 결과 없음 -->
            <div v-else-if="!isLoading" class="mt-5 text-center py-10">
              <p class="text-gray-600">검색 결과가 없습니다.</p>
            </div>
          </div>
          <p class="text-sm text-neutral-400 mt-2">{{ currentTime }}</p>
        </div>
      </div>

      <div class="w-full flex justify-between items-center gap-3">
        <router-link to="/mall/ai-search" class="w-full text-center text-sm border border-neutral-200 rounded-lg px-4 py-3 hover:bg-neutral-50"> 채팅으로 돌아가기 </router-link>
        <button @click="restartSearch" class="w-full text-sm border border-neutral-200 rounded-lg px-4 py-3 hover:bg-neutral-50">분석 다시 하기</button>
      </div>
    </div>
  </main>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import axios from "axios";

// 오늘 날짜를 포맷팅하는 함수
const getFormattedDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");

  const dayNames = ["일", "월", "화", "수", "목", "금", "토"];
  const dayName = dayNames[today.getDay()];

  return `${year}. ${month}. ${day} (${dayName})`;
};

// 현재 시간을 포맷팅하는 함수
const getFormattedTime = () => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");

  return `${hours}:${minutes}`;
};

// 현재 날짜
const currentDate = ref(getFormattedDate());

// 현재 시간
const currentTime = ref(getFormattedTime());

const searchKeywords = ref([]);
const searchQuestion = ref("");
const searchResults = ref(null);
const isLoading = ref(false);

// 페이징 관련 상태
const currentPage = ref(1);
const pageSize = ref(10);
const totalItems = ref(0);
const allItems = ref([]);

// 더 많은 결과가 있는지 확인
const hasMoreResults = computed(() => {
  if (!searchResults.value?.pageInfo) return false;
  return searchResults.value.pageInfo.next;
});

// URL 쿼리 파라미터에서 키워드 초기화
const initializeFromQuery = () => {
  searchKeywords.value = JSON.parse(localStorage.getItem("searchKeywords"));
  searchQuestion.value = localStorage.getItem("searchQuestion");

  console.log("Initialized keywords:", searchKeywords.value);
  console.log("Initialized question:", searchQuestion.value);
};

const searchContents = async (page = 1, append = false) => {
  if (searchKeywords.value.length > 0) {
    isLoading.value = true;

    let params = `?page=${page}`;
    params += `&size=${pageSize.value}`;
    params += "&prop=id";
    params += "&dir=DESC";
    params += "&pageUnitSize=30";

    searchKeywords.value.forEach((keyword) => {
      params += "&keyword=" + encodeURIComponent(keyword);
    });

    console.log("Search parameters:", params);

    try {
      const res = await axios.get("/new_api/open/item/nl/v1/pagination" + params);

      const data = res.data;
      if (data.code === "200") {
        // API 응답 구조: data.data.items, data.data.pageInfo
        searchResults.value = data.data;
        console.log("Search results:", data.data);
        totalItems.value = data.data.pageInfo.total;

        // append가 true면 기존 결과에 추가, false면 새로 시작
        if (append) {
          allItems.value = [...allItems.value, ...data.data.items];
        } else {
          allItems.value = data.data.items;
        }

        console.log("Search results items:", data.data.items);
        console.log("Page info:", data.data.pageInfo);
        console.log("Total loaded items:", allItems.value.length);
      }
    } catch (error) {
      console.error("Search error:", error);
    } finally {
      isLoading.value = false;
    }
  } else {
    console.log("검색 키워드가 없습니다.");
  }
};

// 더보기 버튼 클릭 핸들러
const loadMoreResults = () => {
  currentPage.value += 1;
  searchContents(currentPage.value, true);
};

// 검색 재시작 핸들러
const restartSearch = () => {
  currentPage.value = 1;
  allItems.value = [];
  searchContents(1, false);
};

// 썸네일 링크 추출 함수
const getThumbnailLink = (item) => {
  if (item.thumbnailList && Array.isArray(item.thumbnailList)) {
    const thumbnail = item.thumbnailList.find((t) => t.thumbnailType === "THUMBNAIL");
    if (thumbnail) {
      return thumbnail.thumbnailLink;
    }
  }
  // fallback for old structure or if thumbnails array is missing but thumbnailLink exists on item
  return item.thumbnailLink || null;
};

onMounted(() => {
  // 쿼리 파라미터에서 키워드 가져오기
  initializeFromQuery();

  // 키워드가 있으면 검색 실행 (첫 페이지)
  if (searchKeywords.value && searchKeywords.value.length > 0) {
    searchContents(1, false);
  }
});
</script>
